/**
 * @file family の学習者候補 (active な child) を取得する hook。
 */

import { useEffect, useState } from "react";
import { fetchFamilyMembers, learnersOf, type FamilyMember } from "../api/members";

export type LearnersState =
  | { status: "loading" }
  | { status: "ready"; learners: FamilyMember[] }
  | { status: "error" };

export function useLearners(familyId: string): LearnersState {
  const [state, setState] = useState<LearnersState>({ status: "loading" });

  useEffect(() => {
    const controller = new AbortController();
    setState({ status: "loading" });
    fetchFamilyMembers(familyId, controller.signal)
      .then((members) => {
        if (!controller.signal.aborted) {
          setState({ status: "ready", learners: learnersOf(members) });
        }
      })
      .catch((err: unknown) => {
        if (controller.signal.aborted) return;
        console.error("[study] failed to load members", err);
        setState({ status: "error" });
      });
    return () => controller.abort();
  }, [familyId]);

  return state;
}
